import React, { lazy, Suspense } from 'react';
import { Router } from './Router/index.web';
import { ROUTES } from './types/global/routes.types';
import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from './module/ProtectedRoute';
import * as Sentry from '@sentry/react';
import { APILoader } from './pages';
import { MainLoading as Loading } from './components/Loading/MainLoading';
import { EsMyProfileContainerLoadingState } from './components/ScreenContainer/EsMyProfileContainer/EsMyProfileContainerLoadingState';
import { DiscoveryShimmer } from './pages/DiscoveryShimmer';
import { ViewContestShimmer } from './pages/ViewContestShimmer';
import { TrendingVideosShimmer } from './pages/TrendingVideosShimmer';
import { ComingSoonShimmer } from './pages/ComingSoonShimmer';
import { ActiveContestShimmer } from './pages/ActiveContestShimmer';
import { WatchShimmer } from './pages/WatchShimmer';
import { UserProjectsShimmer } from './pages/UserProjectsShimmer';
import { FooterPageShimmer } from './pages/FooterPageShimmer';
import { JuryPageShimmer } from './pages/JuryPageShimmer';
import { SearchContainerShimmer } from './pages/SearchContainerShimmer';
import { E_USER_PERMISSIONS } from './types/global/user.models';
import { Spinner } from './components/Loading/Spinner';

const BuzzBridgeDashboard = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BuzzBridgeDashboard };
    }),
);

const WorkShop = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.WorkShop };
    }),
);

const ProjectDetails = lazy(() =>
    //@ts-ignore
    import('./pages/ProjectDetails').then(module => {
        return { default: module.ProjectDetails };
    }),
);

const WorkProfile = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.WorkProfile };
    }),
);

const Company = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Company };
    }),
);

const BuzzBridgeDetails = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BuzzBridgeDetails };
    }),
);

const BuzzBridge = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BuzzBridgeLandingPage };
    }),
);

const OAuthCallbackPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.OAuthCallbackPage };
    }),
);

const Messages = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Messages };
    }),
);
const ConversationView = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ConversationView };
    }),
);

const ManageAudition = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ManageAudition };
    }),
);

const Events = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Events };
    }),
);

const EventDetails = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.EventDetails };
    }),
);

const Audition = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Audition };
    }),
);

const AuditionDetails = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AuditionDetails };
    }),
);

const AccountSettings = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountSettings };
    }),
);

const AccountBilling = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountBilling };
    }),
);
const AccountCommunications = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountCommunications };
    }),
);
const AccountNotifications = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountNotifications };
    }),
);
const AccountPreference = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountPreference };
    }),
);

const AccountHelp = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountHelp };
    }),
);

const AccountPreferences = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountPreference };
    }),
);

const AccountSubscription = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountSubscriptions };
    }),
);
const AccountExternalBankAccounts = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountExternalBankAccounts };
    }),
);

// const HomePage = en_config.WIP ? Splash : Home;
const EsDiscovery = lazy(() =>
    //@ts-ignore
    import('./pages/EsDiscovery/EsDiscovery').then(module => {
        return { default: module.EsDiscovery };
    }),
);

const AppLayout = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AppLayout };
    }),
);

const EsLogin = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.EsLogin };
    }),
);

const Signup = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Signup };
    }),
);
const ModernPageNotFound = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ModernPageNotFound };
    }),
);
const PrivacyPolicy = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.PrivacyPolicy };
    }),
);
const HelpCenter = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.HelpCenter };
    }),
);
const FAQ = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.FAQ };
    }),
);
const Search = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Search };
    }),
);
const Shop = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Shop };
    }),
);
const TermsOfUse = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.TermsOfUse };
    }),
);
const ErrorBoundary = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ErrorBoundary };
    }),
);

const EsSettings = lazy(() =>
    //@ts-ignore
    import('./pages/EsSettings').then(module => {
        return { default: module.EsSettings };
    }),
);

const EsMyProfile = lazy(() =>
    //@ts-ignore
    import('./pages/EsMyProfile').then(module => {
        return { default: module.EsMyProfile };
    }),
);

const ManageCampaign = lazy(() =>
    //@ts-ignore
    import('./pages/ManageCampaign').then(module => {
        return { default: module.ManageCampaign };
    }),
);

const EsViewContest = lazy(() =>
    //@ts-ignore
    import('./pages/EsViewContest').then(module => {
        return { default: module.EsViewContest };
    }),
);

const Event = lazy(() =>
    //@ts-ignore
    import('./pages/EsViewContest').then(module => {
        return { default: module.Event };
    }),
);

const EsComingSoon = lazy(() =>
    //@ts-ignore
    import('./pages/EsComingSoon').then(module => {
        return { default: module.EsComingSoon };
    }),
);

const Dashboard = lazy(() =>
    //@ts-ignore
    import('./pages/MenuDashboard').then(module => {
        return { default: module.Dashboard };
    }),
);

const Talents = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Talents };
    }),
);

const FindTalents = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.FindTalents };
    }),
);

const UserProjects = lazy(() =>
    //@ts-ignore
    import('./pages/UserProjects').then(module => {
        return { default: module.UserProjects };
    }),
);

const EsJoinContest = lazy(() =>
    //@ts-ignore
    import('./pages/EsJoinContest').then(module => {
        return { default: module.EsJoinContest };
    }),
);

const EsLiveContests = lazy(() =>
    //@ts-ignore
    import('./pages/EsLiveContests').then(module => {
        return { default: module.EsLiveContests };
    }),
);

const EsAllContests = lazy(() =>
    //@ts-ignore
    import('./pages/EsAllContests').then(module => {
        return { default: module.EsAllContests };
    }),
);

const EsJuryDuty = lazy(() =>
    //@ts-ignore
    import('./pages/EsJuryDuty').then(module => {
        return { default: module.EsJuryDuty };
    }),
);

const EsActiveContest = lazy(() =>
    //@ts-ignore
    import('./pages/EsActiveContest').then(module => {
        return { default: module.EsActiveContest };
    }),
);

const EsTrendingVideos = lazy(() =>
    //@ts-ignore
    import('./pages/EsTrendingVideos').then(module => {
        return { default: module.EsTrendingVideos };
    }),
);

const EsWatchVideo = lazy(() =>
    //@ts-ignore
    import('./pages/EsWatchVideo').then(module => {
        return { default: module.EsWatchVideo };
    }),
);

const Watch = lazy(() =>
    //@ts-ignore
    import('./pages/EsWatchVideo').then(module => {
        return { default: module.Watch };
    }),
);

const EsNewPassword = lazy(() =>
    //@ts-ignore
    import('./pages/EsNewPassword/EsNewPassword').then(module => {
        return { default: module.EsNewPassword };
    }),
);

const EsResetPassword = lazy(() =>
    //@ts-ignore
    import('./pages/EsResetPassword').then(module => {
        return { default: module.EsResetPassword };
    }),
);

const VerifyEmail = lazy(() =>
    //@ts-ignore
    import('./pages/VerifyEmail').then(module => {
        return { default: module.VerifyEmail };
    }),
);

const JuryAcceptance = lazy(() =>
    //@ts-ignore
    import('./pages/JuryAcceptance').then(module => {
        return { default: module.JuryAcceptance };
    }),
);

const Links = lazy(() =>
    //@ts-ignore
    import('./pages/Links').then(module => {
        return { default: module.Links };
    }),
);

const Feed = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Feed };
    }),
);

const ContestSubmissions = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ContestSubmissions };
    }),
);

const ManageEvent = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ManageEvent };
    }),
);

const ManageContest = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ManageContest };
    }),
);

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(Router);

export const router = sentryCreateBrowserRouter([
    {
        path: ROUTES.HOME,
        element: (
            <Suspense fallback={<Loading />}>
                <AppLayout />
            </Suspense>
        ),
        errorElement: <ModernPageNotFound />,
        children: [
            { index: true, element: <Navigate to={ROUTES.API_LOADER} replace /> },
            {
                path: ROUTES.API_LOADER,
                element: <APILoader />,
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.AUDITION,
                element: (
                    <Suspense fallback={<Loading />}>
                        <Audition />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.MANAGE_AUDITION,
                element: (
                    <Suspense fallback={<Loading />}>
                        <ManageAudition />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.WORK_PROFILE,
                element: (
                    <Suspense fallback={<Loading />}>
                        <WorkProfile />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.COMPANY,
                element: (
                    <Suspense fallback={<Loading />}>
                        <Company />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.GIG,
                element: (
                    <Suspense fallback={<Loading />}>
                        <Audition />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.AUDITION_DETAIL,
                element: (
                    <Suspense fallback={<Loading />}>
                        <AuditionDetails />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.GIG_DETAIL,
                element: (
                    <Suspense fallback={<Loading />}>
                        <AuditionDetails />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.EVENTS,
                element: (
                    <Suspense fallback={<Loading />}>
                        <Events />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.FEED,
                element: (
                    <Suspense fallback={<Loading />}>
                        <Feed />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.EVENT_DETAILS,
                element: (
                    <Suspense fallback={<ViewContestShimmer />}>
                        <EventDetails />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
                action: () => {},
                loader: async () => {
                    return true;
                },
                caseSensitive: true,
                hasErrorBoundary: true,
            },
            {
                path: ROUTES.ESDISCOVERY,
                element: (
                    <Suspense fallback={<DiscoveryShimmer />}>
                        <EsDiscovery />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESWATCH_VIDEO,
                element: (
                    <Suspense fallback={<WatchShimmer />}>
                        <EsWatchVideo />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESTRENDING,
                element: (
                    <Suspense fallback={<TrendingVideosShimmer />}>
                        <EsTrendingVideos />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESCONTEST,
                element: (
                    <Suspense fallback={<ActiveContestShimmer />}>
                        <ProtectedRoute>
                            <EsActiveContest />
                        </ProtectedRoute>
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESALL_CONTESTS,
                element: (
                    <Suspense fallback={<Loading />}>
                        <EsAllContests />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESJOIN_CONTESTS,
                element: (
                    <Suspense fallback={<Loading />}>
                        <ProtectedRoute>
                            <EsJoinContest />
                        </ProtectedRoute>
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESLIVE_CONTESTS,
                element: <EsLiveContests />,
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESJURY_DUTY,
                element: (
                    <ProtectedRoute
                        accessCheck
                        accessType={[
                            E_USER_PERMISSIONS.SUPER_ADMIN,
                            E_USER_PERMISSIONS.ADMIN,
                            E_USER_PERMISSIONS.JURY,
                        ]}>
                        <Suspense fallback={<JuryPageShimmer />}>
                            <EsJuryDuty />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.BUZZ_BRIDGE,
                element: (
                    <ProtectedRoute
                        accessCheck
                        accessType={[
                            E_USER_PERMISSIONS.SUPER_ADMIN,
                            E_USER_PERMISSIONS.ADMIN,
                            E_USER_PERMISSIONS.INFLUENCER,
                        ]}>
                        <Suspense fallback={<Loading />}>
                            <BuzzBridgeDashboard />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.BUZZ_BRIDGE_DETAILS,
                element: (
                    <ProtectedRoute
                        accessCheck
                        accessType={[
                            E_USER_PERMISSIONS.SUPER_ADMIN,
                            E_USER_PERMISSIONS.ADMIN,
                            E_USER_PERMISSIONS.INFLUENCER,
                        ]}>
                        <Suspense fallback={<Loading />}>
                            <BuzzBridgeDetails />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.TALENTS,
                element: (
                    <ProtectedRoute
                        accessCheck
                        accessType={[
                            E_USER_PERMISSIONS.SUPER_ADMIN,
                            E_USER_PERMISSIONS.ADMIN,
                            E_USER_PERMISSIONS.CASTING_DIRECTOR,
                        ]}>
                        <Suspense fallback={<Loading />}>
                            <Talents />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.DISCOVER,
                element: (
                    <Suspense fallback={<Loading />}>
                        <FindTalents />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESCOMING_SOON,
                element: (
                    <Suspense fallback={<ComingSoonShimmer />}>
                        <EsComingSoon />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.DASHBOARD,
                element: (
                    <ProtectedRoute>
                        <Suspense fallback={<Loading />}>
                            <Dashboard />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.CONTEST_SUBMISSIONS,
                element: (
                    <Suspense fallback={<ViewContestShimmer />}>
                        <ContestSubmissions />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
                caseSensitive: true,
                hasErrorBoundary: true,
            },
            {
                path: ROUTES.ESVIEW_CONTEST,
                element: (
                    <Suspense fallback={<ViewContestShimmer />}>
                        <EsViewContest />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
                action: () => {},
                loader: async () => {
                    return true;
                },
                caseSensitive: true,
                hasErrorBoundary: true,
            },
            {
                path: ROUTES.ESCONTEST_ENGAGE,
                element: (
                    <ProtectedRoute accessCheck accessType="admin">
                        <Suspense fallback={<ViewContestShimmer />}>
                            <ManageCampaign />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESMY_VIDEOS,
                element: (
                    <ProtectedRoute>
                        <Suspense fallback={<UserProjectsShimmer />}>
                            <UserProjects />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESMY_PROFILE,
                element: (
                    <ProtectedRoute>
                        <Suspense fallback={<EsMyProfileContainerLoadingState />}>
                            <EsMyProfile />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.USER,
                element: (
                    <ProtectedRoute>
                        <Suspense fallback={<EsMyProfileContainerLoadingState />}>
                            <EsMyProfile />
                        </Suspense>
                    </ProtectedRoute>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.SEARCH,
                element: (
                    <Suspense fallback={<SearchContainerShimmer />}>
                        <Search />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.ESSETTINGS,
                element: (
                    <Suspense fallback={<Loading />}>
                        <ProtectedRoute>
                            <EsSettings />
                        </ProtectedRoute>
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
            {
                path: ROUTES.EVENT_CUSTOM,
                element: (
                    <Suspense fallback={<ViewContestShimmer />}>
                        <Event />
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
                action: () => {},
                loader: async () => {
                    return true;
                },
                caseSensitive: true,
                hasErrorBoundary: true,
            },
            {
                path: ROUTES.ACCOUNT,
                element: (
                    <Suspense fallback={<Spinner />}>
                        <ProtectedRoute>
                            <AccountSettings />
                        </ProtectedRoute>
                    </Suspense>
                ),
                errorElement: <ModernPageNotFound />,
                children: [
                    {
                        path: ROUTES.ACCOUNT_SETTINGS,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <EsSettings />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                        index: true,
                    },
                    {
                        path: ROUTES.ACCOUNT_BILLING,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <AccountBilling />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                    },
                    {
                        path: ROUTES.ACCOUNT_NOTIFICATIONS,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <AccountNotifications />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                    },
                    {
                        path: ROUTES.ACCOUNT_COMMUNICATIONS,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <AccountCommunications />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                    },
                    {
                        path: ROUTES.ACCOUNT_PREFERENCE,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <AccountPreference />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                    },
                    {
                        path: ROUTES.ACCOUNT_HELP,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <AccountHelp />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                    },
                    {
                        path: ROUTES.ACCOUNT_PREFERENCES,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <AccountPreferences />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                    },
                    {
                        path: ROUTES.ACCOUNT_SUBSCRIPTION,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <AccountSubscription />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                    },
                    {
                        path: ROUTES.ACCOUNT_EXTERNAL_ACCOUNT,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ProtectedRoute>
                                    <AccountExternalBankAccounts />
                                </ProtectedRoute>
                            </Suspense>
                        ),
                        errorElement: <ErrorBoundary />,
                    },
                ],
            },
            {
                path: ROUTES.MESSAGES,
                element: (
                    <ProtectedRoute>
                        <Suspense fallback={<Spinner />}>
                            <Messages />
                        </Suspense>
                    </ProtectedRoute>
                ),
                children: [
                    {
                        path: ROUTES.MESSAGES_CONVERSATION,
                        element: (
                            <Suspense fallback={<Spinner />}>
                                <ConversationView />
                            </Suspense>
                        ),
                    },
                ],
            },
            {
                path: ROUTES.MANAGE_EVENT,
                element: (
                    <Suspense fallback={<Loading />}>
                        <ProtectedRoute>
                            <ManageEvent />
                        </ProtectedRoute>
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },

            {
                path: ROUTES.MANAGE_CONTEST,
                element: (
                    <Suspense fallback={<Loading />}>
                        <ProtectedRoute accessCheck accessType={['admin', 'host', 'super-admin']}>
                            <ManageContest />
                        </ProtectedRoute>
                    </Suspense>
                ),
                errorElement: <ErrorBoundary />,
            },
        ],
    },
    {
        path: ROUTES.ESNEWPASSWORD,
        element: (
            <Suspense fallback={<Loading />}>
                <EsNewPassword />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.WORK_SHOP,
        element: (
            <Suspense fallback={<Loading />}>
                <ProtectedRoute>
                    <WorkShop />
                </ProtectedRoute>
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.PROJECT_DETAILS,
        element: (
            <Suspense fallback={<Loading />}>
                <ProjectDetails />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.WATCH,
        element: (
            <Suspense fallback={<WatchShimmer />}>
                <Watch />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.ESSIGNUP,
        element: (
            <Suspense fallback={<Loading />}>
                <Signup />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.ESRESETPASSWORD,
        element: (
            <Suspense fallback={<Loading />}>
                <EsResetPassword />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.VERIFY_EMAIL,
        element: (
            <Suspense fallback={<Loading />}>
                <VerifyEmail />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.ACCEPT_JURY_INVITE,
        element: (
            <Suspense fallback={<Loading />}>
                <JuryAcceptance />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.BUZZ_BRIDGE_LANDING,
        element: (
            <Suspense fallback={<Loading />}>
                <BuzzBridge />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.LINKS,
        element: (
            <Suspense fallback={<Loading />}>
                <Links />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.ESLOGIN,
        element: (
            <Suspense fallback={<Loading />}>
                <EsLogin />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.FAQ,
        element: (
            <Suspense fallback={<Loading />}>
                <FAQ />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.HELP_CENTER,
        element: (
            <Suspense fallback={<FooterPageShimmer />}>
                <HelpCenter />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.TERMS_OF_USE,
        element: (
            <Suspense fallback={<FooterPageShimmer />}>
                <TermsOfUse />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.SHOP,
        element: (
            <Suspense fallback={<Loading />}>
                <Shop />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.PRIVACY_POLICY,
        element: (
            <Suspense fallback={<FooterPageShimmer />}>
                <PrivacyPolicy />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: ROUTES.SOCIAL_AUTH_PAGE,
        element: <OAuthCallbackPage />,
    },
    {
        path: '*',
        element: (
            <Suspense fallback={<Loading />}>
                <ModernPageNotFound />
            </Suspense>
        ),
    },
]);
